import React, { Fragment, useState } from "react";
import { reactUtils } from "utilities";
import { ShimmerCompanyCard } from "CompanyCard";
import CompanyCardGrid from "CompanyCardGrid";
import HeadlessCompanySearch from "HeadlessCompanySearch";
import "./styles.scss";
import { usePortfolio } from "queryHooks";

export const PortfolioLandingPage = ({
  portfolioId,
  userId,
  baselineCompanyIds,
  portfolioTagId,
}) => {
  const {
    status,
    data: portfolio,
    error,
    isFetching,
  } = usePortfolio({
    portfolioId,
  });

  if (portfolio) {
    document.title = portfolio.landing_page_title;
  }

  return (
    <Fragment>
      {portfolio && (
        <div>
          {/* <img
            className="ps-hero--dynamic"
            style={{ height: "350px", width: "100%", objectFit: "cover" }}
            src={
              portfolio.portfolio_card_banner_image_url
                ? portfolio.portfolio_card_banner_image_url
                : ""
            }
          ></img> */}
          <div
            className="container js-class-landing-page"
            data-class-name={portfolio.name}
          >
            <div className="content-hero">
              <div className="row">
                <div className="col-12 col-md-8 mt-5">
                  <h1 className="font-weight-bold">
                    {portfolio.landing_page_title}
                  </h1>
                </div>
              </div>
              <hr className="ps-divider--primary mt-5" />
              <div className="row mt-5">
                <div className="col-12 col-md-7">
                  <span className="ps-label">
                    {portfolio.landing_page_about_label_text}
                  </span>

                  <div
                    className="p-lg mt-3"
                    dangerouslySetInnerHTML={{
                      __html: reactUtils.quillDeltaToHtml(
                        portfolio.landing_page_about_json
                      ),
                    }}
                  ></div>
                </div>
                <div className="col-12 col-md-5">
                  <div className="float-left float-md-right">
                    <div className="text-center">
                      <div>
                        <span className="ps-label">
                          {portfolio.landing_page_manager_logo_label_text}
                        </span>
                        <div>
                          <a
                            href={
                              portfolio.landing_page_portfolio_manager_logo_link_url
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              style={{ width: "200px", marginBottom: "30px" }}
                              className="mt-3"
                              src={
                                portfolio.landing_page_portfolio_manager_logo_image_url
                              }
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <HeadlessCompanySearch
                showMarketTags
                showLocationTags
                showPortfolioTags
                showInvestmentRoundTags
                companyVisibility={["public", "portfolio_only"]}
                pageSize={12}
                showRealCompanyTotalCount
                baselinePortfolioTagIds={[portfolioTagId]}
                baselineCompanyIds={baselineCompanyIds}
                apiSlug={`companies`}
                defaultShowFilters={true}
                renderSwitch={false}
                generateChildren={(companies) => {
                  return (
                    <CompanyCardGrid
                      companies={companies}
                      useNamespaceTags={true}
                      useCompanyCardAnchorLink={true}
                    />
                  );
                }}
                generateLoading={() => {
                  return (
                    <div className="ps-flex-grid js-class-list ps-class-list">
                      {[1, 2, 3, 4, 5, 6].map((x, i) => {
                        return (
                          <div className="ps-flex-grid__item" key={i}>
                            <ShimmerCompanyCard key={i} />
                          </div>
                        );
                      })}
                    </div>
                  );
                }}
              />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
